if (!customElements.get('product-recently')) {
  customElements.define(
    'product-recently',
    class ProductRecently extends HTMLElement {
      constructor() {
        super()
        this.cookieKeyName = 'shopify_recently_viewed'
        this.productHandle = this.dataset.productHandle
        this.showMax = Number(this.dataset.max)
        this.sep = ' '
        this.showProducts = []
        this.productRecently = document.getElementById('product-recently')
        this.initCookie()
        this.init()
        this.show()
      }

      initCookie() {
        if (!Cookies.get(this.cookieKeyName)) {
          Cookies.set(this.cookieKeyName, '')
        }
      }

      init() {
        const cookieData = Cookies.get(this.cookieKeyName)
        const products = cookieData !== '' ? cookieData.split(this.sep) : []
        const realMax = this.showMax + 1
        let newProducts = []
        if (products.find((product) => product === this.productHandle)) {
          newProducts = products.filter((product) => product !== this.productHandle)
          newProducts = [this.productHandle, ...newProducts]
        } else {
          newProducts = [this.productHandle, ...products]
          if ([...products, this.productHandle].length > realMax) {
            newProducts.length = realMax
          }
        }
        Cookies.set(this.cookieKeyName, newProducts.join(this.sep))
        this.showProducts = newProducts.filter((product) => product !== this.productHandle)
      }

      show() {
        const urlList = this.showProducts.map(
          (handle) => `${window.Shopify.routes.root}products/${handle}?section_id=card-product`,
        )

        const fetchList = urlList.map((url) => fetch(url).then((response) => response.text()).catch((error) => console.log(error)))
        Promise.all(fetchList)
          .then((responseTexts) => {
            for (const responseText of responseTexts) {
              if (responseText.indexOf('<div>Product not found</div>') !== -1) {
                continue
              }
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const section = html.querySelector(
                `.shopify-section`
              );
              this.productRecently.innerHTML += `<div class="col">${section.innerHTML}</div>`
            }
          })
      }
    }
  )
}
